module.exports = __webpack_public_path__ + "img/MEDIA020.7f41cc29.jpg";